import React from 'react';
import ScoreCard from './ScoreCard';

function ConfidenceMeter({ distributionScore, confidenceScore }) {
  return (
    <section className="score-grid" aria-label="Analiza variantei">
      <ScoreCard
        label="SCOR DISTRIBUȚIE"
        score={distributionScore}
        description="Paritate, interval, sumă și dispersie numerică."
      />
      <ScoreCard
        label="SCOR ALGORITMIC*"
        score={confidenceScore}
        description="Compatibilitate cu profilul statistic echilibrat."
        accent
      />
      <p className="score-disclaimer">
        *Scor comparativ, nu probabilitate de câștig. Toate combinațiile valide
        au aceeași șansă matematică la extragere.
      </p>
    </section>
  );
}

export default ConfidenceMeter;